import type { Endpoint, Route, Request, RequestArgs } from '../types.no-deps'
import type { OngoingReport, ServerOngoingReport } from '../../../shared/domain/reports/ongoingReport.no-deps'
import type { ReportId } from '../../../shared/domain/flows/types.no-deps'
import type { Nullable } from '../../../shared/lib/typeHelpers.no-deps'

export const route: Route = { method: 'GET', pattern: '/api/reports/ongoing' }

type Params = never
type Body = never
type Query = { reportClientId: ReportId }
type Output = {
    report: ServerOngoingReport
    scheduledInstance: Nullable<OngoingReport['scheduledInstance']>
}

export type GetOngoingEndpoint = Endpoint<Params, Body, Query, Output>

export const getOngoingRequest = (request: Request, args: RequestArgs<GetOngoingEndpoint>) =>
    request<GetOngoingEndpoint>(route, args)
